import React, { MouseEventHandler } from 'react';
import * as S from './Long.styles';

interface ButtonProps {
  primary?: boolean;
  backgroundColor?: string;
  size?: 'small' | 'medium' | 'large';
  label: string;
  onClick?: () => void;
}

export const Button = ({
  primary = true,
  size = 'small',
  backgroundColor,
  label,
  ...props
}: ButtonProps) => {
  const mode = primary ? 'button-long--primary' : 'button-long--secondary';
  return (
    <S.Button
      type="button"
      className={['button-long', `button-long--${size}`, mode].join(' ')}
      style={{ backgroundColor }}
      {...props}
    >
      {label}
    </S.Button>
  );
};
